import { useCallback } from 'react';

import { useDialogs } from '../../../../dialog-manager/use-dialogs';

import { TicketSolutionDialog } from './TicketSolutionDialog';

export const useTicketSolutionDialog = () => {
  const dialogs = useDialogs();

  return useCallback(
    () =>
      new Promise<string>((resolve) => {
        const onClose = () => {
          resolve('');
          dialogs.close(id);
        };

        const onConfirm = (input: string) => {
          resolve(input);
          dialogs.close(id);
        };

        const { id } = dialogs.open(TicketSolutionDialog, {
          onConfirm,
          onClose,
        });
      }),
    [dialogs]
  );
};
